<template>
  <transition>
    <div
      v-if="filterToggle"
      class="pt-2"
    >
      <b-form
        class="border-dashed"
      >
        <b-row>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.DC_TYPE))"
              :label-for="MonitoringInno.DC_TYPE"
            >
              <v-select
                :id="MonitoringInno.DC_TYPE"
                v-model="filters[MonitoringInno.DC_TYPE]"
                multiple
                :reduce="(option) => option.id"
                :options="dcTypes"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.REGION))"
              :label-for="MonitoringInno.REGION"
            >
              <v-select
                :id="MonitoringInno.REGION"
                v-model="filters[MonitoringInno.REGION]"
                :reduce="(option) => option.id"
                :options="regions"
                :placeholder="$t('All')"
                :get-option-label="(option) => $langName(option.name)"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.ORGANIZATION))"
              :label-for="MonitoringInno.ORGANIZATION"
            >
              <v-select
                :id="MonitoringInno.ORGANIZATION"
                v-model="filters[MonitoringInno.ORGANIZATION]"
                :reduce="(option) => option.id"
                :options="universityList"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
                @input="selectDirections"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="directions.length"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.DIRECTION))"
              :label-for="MonitoringInno.DIRECTION"
            >
              <v-select
                :id="MonitoringInno.DIRECTION"
                v-model="filters[MonitoringInno.DIRECTION]"
                :reduce="(option) => option.id"
                :options="directions"
                :get-option-label="(option) => option.code + ' - ' + $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.PERIOD))"
              :label-for="MonitoringInno.PERIOD"
            >
              <v-select
                id="period"
                v-model="filters[MonitoringInno.PERIOD]"
                :options="periods"
                :get-option-label="(option) => option.admission_year + '-' + option.name"
                :placeholder="$t('All')"
                @input="selectQuarter"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="filters[MonitoringInno.PERIOD]"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.QUARTER))"
              :label-for="MonitoringInno.QUARTER"
            >
              <v-select
                :id="MonitoringInno.QUARTER"
                v-model="filters[MonitoringInno.QUARTER]"
                :reduce="(option) => option.id"
                :options="filters[MonitoringInno.PERIOD].quarters"
                :get-option-label="(option) => option.quarter"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.COURSE))"
              :label-for="MonitoringInno.COURSE"
            >
              <v-select
                :id="MonitoringInno.COURSE"
                v-model="filters[MonitoringInno.COURSE]"
                :options="[1,2,3]"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.STATUS))"
              :label-for="MonitoringInno.STATUS"
            >
              <v-select
                :id="MonitoringInno.STATUS"
                v-model="filters[MonitoringInno.STATUS]"
                :reduce="(option) => option.id"
                :options="statuses"
                :get-option-label="(option) => $langName(option)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.REPORT_STATUS))"
              :label-for="MonitoringInno.REPORT_STATUS"
            >
              <v-select
                :id="MonitoringInno.REPORT_STATUS"
                v-model="filters[MonitoringInno.REPORT_STATUS]"
                :reduce="(option) => option.id"
                :options="reportStatuses"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.REASON_STATUS))"
              :label-for="MonitoringInno.REASON_STATUS"
            >
              <v-select
                :id="MonitoringInno.REASON_STATUS"
                v-model="filters[MonitoringInno.REASON_STATUS]"
                :reduce="(option) => option.id"
                :options="reasonStatuses"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.SCHOLARSHIP_STATUS))"
              :label-for="MonitoringInno.SCHOLARSHIP_STATUS"
            >
              <v-select
                :id="MonitoringInno.SCHOLARSHIP_STATUS"
                v-model="filters[MonitoringInno.SCHOLARSHIP_STATUS]"
                :reduce="(option) => option.id"
                :options="scholarshipStatuses"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(MonitoringInno.ADVISOR))"
              :label-for="MonitoringInno.ADVISOR"
            >
              <v-select
                :id="MonitoringInno.ADVISOR"
                :value="filters[MonitoringInno.ADVISOR]"
                :options="advisorList"
                :reduce="(option) => option.id"
                :get-option-label="(option) => option.full_name"
                :placeholder="$t('All')"
                @search="fetchAdvisor"
                @input="inputAdvisor"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              class="mr-1"
              variant="success"
              @click="onFilter"
            >
              <feather-icon icon="LFilterIcon" />
              {{ $t('Filter') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </transition>
</template>

<script>
import vSelect from 'vue-select'
import {
  BButton, BCol, BForm, BFormGroup, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { isObject } from '@core/utils/utils'
import axios from '@/libs/axios'
import MonitoringInno from '@/views/components/filters/service/MonitoringInno'

export default {
  name: 'FilterComponent',
  components: {
    BForm,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    filterToggle: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: [Array, Object],
      default: () => ({}),
    },
    filterClass: {
      type: [Object, null],
      default: null,
    },
    selectedFilters: {
      type: [Array],
      default: () => ([]),
    },
  },
  data() {
    return {
      period: null,
      advisors: [],
      selectedAdvisor: null,
    }
  },
  computed: {
    MonitoringInno() {
      return MonitoringInno
    },
    dcTypes() {
      return this.$store.state.staticModule.dcTypes
    },
    statuses() {
      return this.$store.state.staticModule.checkMonitoringStatus
    },
    reportStatuses() {
      return this.$store.state.monitoringReport.statuses
    },
    reasonStatuses() {
      return this.$store.state.staticModule.checkMonitoringStatusWithName
    },
    scholarshipStatuses() {
      return this.$store.state.staticModule.scholarshipStatuses
    },
    universityList() {
      return this.$store.state.staticModule.universityList
    },
    researchAdvisors() {
      return this.$store.state.staticModule.researchAdvisors
    },
    directions() {
      return this.$store.state.staticModule.directionList
    },
    periods() {
      return this.$store.state.staticModule.periodList
    },
    regions() {
      return this.$store.state.staticModule.regions
    },
    genders() {
      return this.$store.state.staticModule.genders
    },
    advisorList() {
      if (this.selectedAdvisor && !this.advisors.find(x => x.id === this.selectedAdvisor.id)) {
        return [this.selectedAdvisor, ...this.advisors]
      }
      return this.advisors
    },
  },
  watch: {
    universityList(newValue) {
      this.changeValue(newValue, MonitoringInno.ORGANIZATION)
    },
    periods(newValue) {
      this.changeValue(newValue, MonitoringInno.PERIOD)
      if (this.filters[MonitoringInno.PERIOD]?.quarters) this.changeValue(this.filters[MonitoringInno.PERIOD].quarters, MonitoringInno.QUARTER)
    },
    regions(newValue) {
      this.changeValue(newValue, MonitoringInno.REGION)
    },
    directions(newValue) {
      this.changeValue(newValue, MonitoringInno.DIRECTION)
    },
  },
  created() {
    this.fetchAdvisor('', () => {})
    if (this.filters[MonitoringInno.ADVISOR]) {
      this.filters[MonitoringInno.ADVISOR] = Number(this.filters[MonitoringInno.ADVISOR])
      this.setSelectedUser()
    }

    if (Array.isArray(this.filters[MonitoringInno.DC_TYPE])) {
      this.filters[MonitoringInno.DC_TYPE] = this.filters[MonitoringInno.DC_TYPE].map(x => Number(x))
    } else if (this.filters[MonitoringInno.DC_TYPE]) {
      this.changeValue(this.dcTypes, MonitoringInno.DC_TYPE)
    }
    if (this.filters[MonitoringInno.ORGANIZATION]) {
      this.selectDirections(this.filters[MonitoringInno.ORGANIZATION])
    }
    this.changeValue(this.statuses, MonitoringInno.STATUS)
    this.changeValue(this.reportStatuses, MonitoringInno.REPORT_STATUS)
    this.changeValue(this.reasonStatuses, MonitoringInno.REASON_STATUS)
    this.changeValue(this.scholarshipStatuses, MonitoringInno.SCHOLARSHIP_STATUS)
  },
  methods: {
    selectDirections(id) {
      if (id) {
        this.$store.dispatch('staticModule/directionList', { org_id: id })
      } else {
        this.$store.commit('staticModule/SET_DIRECTION_LIST', [])
      }
    },
    selectQuarter() {
      this.filters[MonitoringInno.QUARTER] = null
    },
    onFilter() {
      this.$emit('onFilter', this.filter)
    },
    onGenerateExel() {
      this.$emit('onGenerateExel', this.filter, MonitoringInno.EXEL_GENERATE_ENDPOINT)
    },
    changeValue(newValue, field) {
      if (newValue.length && !isObject(this.filters[field])) {
        this.filters[field] = newValue.find(x => `${x.id}` === this.filters[field])
      }
    },
    fetchAdvisor(search, loading) {
      loading(true)
      this.$store.dispatch('staticModule/researchAdvisors', { search }).then(res => {
        this.advisors = res
        loading(false)
      })
    },
    setSelectedUser() {
      axios.get(`auth/users/${this.filters[MonitoringInno.ADVISOR]}`).then(({ data }) => {
        this.selectedAdvisor = data
      })
    },
    inputAdvisor(id) {
      this.selectedAdvisor = this.advisors.find(x => x.id === id)
      this.filters[MonitoringInno.ADVISOR] = id
    },
  },
}
</script>

<style scoped>

</style>
